import styled from 'styled-components';

import { breakpoints } from '@/shared/styles';
import { Theme } from '@/shared/themes';

export const Container = styled.div`
  display: flex;
  width: 100%;

  border-radius: 48px;
  overflow: hidden;
  position: relative;
  padding: 12px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: unset;

  @media (min-width: ${breakpoints.mobileLG}px) {
    padding: 34px 40px;
    border-radius: ${({ theme }: { theme: Theme }) => theme.common.earnBanner.borderRadius};
  }

  @media (min-width: ${breakpoints.tabletLG}px) {
    padding: 24px 24px;
  }

  @media (min-width: ${breakpoints.laptopSM}px) {
    height: 200px;
    padding: 34px 40px;
  }

  & > svg {
    display: none;
    @media (min-width: ${breakpoints.laptopSM}px) {
      display: unset;
    }

    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 0;
    user-select: none;
    position: absolute;
    top: 0;
    left: 0;
  }
`;
